<script setup lang="ts">
import ChatMessage from "@/views/ChatMessage/ChatMessage.vue";
import { isCompactMode } from "@/data/pubilc";
import { chatList } from "@/views/Home/useData/module/chat";
import ChatCover from "@/components/Dialogues/Chat/ChatCover.vue";

import publicStore from "@/store/publicStore";
import { storeToRefs } from "pinia";
import { watch } from "vue";
const { isLogin } = storeToRefs(publicStore());
</script>

<template>
  <div class="base" :class="{ 'compact-base': isCompactMode }">
    <div class="content">
      <ChatCover v-if="chatList.length === 0 || !isLogin" />
      <ChatMessage v-else />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.base {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.compact-base {
  padding: 0 5px !important;
}
</style>
